// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationAddress } from './priorAuthorizationAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationProvider {
    'firstName': string;
    'lastName': string;
    'npi': string;
    'providerType': Array<string>;
    'specialty': string;
    'phone': string;
    'phoneExtension'?: string;
    'address'?: PriorAuthorizationAddress | null;
    'fax'?: string;
    'taxId'?: string;
    'ptan'?: string;
    'organizationName'?: string;
    'contactName'?: string;
    'email'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationProvider>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "providerType",
            "baseName": "providerType",
            "type":     "Array<string>"
        },
        {
            "name":     "specialty",
            "baseName": "specialty",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "phoneExtension",
            "baseName": "phoneExtension",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PriorAuthorizationAddress"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "ptan",
            "baseName": "ptan",
            "type":     "string"
        },
        {
            "name":     "organizationName",
            "baseName": "organizationName",
            "type":     "string"
        },
        {
            "name":     "contactName",
            "baseName": "contactName",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationProvider.attributeTypeMap;
    }
}
